// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__KZBto","image":"Header_image__33h7V","name":"Header_name__86Qun","info":"Header_info__1O8_8","infoRow":"Header_infoRow__2WeTp"};